import cxs from 'cxs/component';
import theme from '../../Theme';
export var ItemSelect = cxs('div')(function (_a) {
    var selected = _a.selected, disabled = _a.disabled;
    return ({
        borderWidth: '1px',
        borderRadius: '10px',
        borderStyle: 'solid',
        borderColor: disabled ? 'white' : selected ? 'green' : 'black',
        padding: '5px',
        margin: '5px 2px',
        backgroundColor: disabled ? 'red' : selected ? 'green' : undefined,
        color: disabled && selected ? 'green' : disabled || selected ? 'white' : undefined,
        ':hover': {
            borderColor: disabled ? undefined : selected ? 'white' : theme.color.primary,
            color: selected || disabled ? undefined : theme.color.primary,
            borderWidth: selected || disabled ? undefined : '2px',
            padding: selected || disabled ? undefined : '4px',
            cursor: selected || disabled ? undefined : 'pointer'
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./src/components/InlineSelect/ItemSelect.tsx
// module id = 1192
// module chunks = 0